import React from 'react';

/**
 * ConflictHeader Component
 * Renders the top part of the Conflict Center with title, status badges, and the detection toggle.
 * 
 * @component
 * @param {Object} props
 * @param {boolean} props.isDetectionEnabled - Current state of global conflict detection
 * @param {number} props.logicalCount - Number of relevant conflicts
 * @param {Function} props.onToggleDetection - Callback to switch detection on/off
 * @param {Function} props.onClose - Callback to close the modal
 */
const ConflictHeader = ({
    isDetectionEnabled,
    logicalCount,
    onToggleDetection,
    onClose
}) => {
    return (
        <div className="co-header">
            <div className="co-title-area">
                <h2>
                    ⚠️ Konflikt-Zentrale
                    {isDetectionEnabled && (
                        <span className="co-badge-count">
                            {logicalCount} relevante Konflikte
                        </span>
                    )}
                </h2>
                <p className="co-subtitle">Alle Terminüberschneidungen und Mehrfachbelegungen im Überblick</p>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                <div className="co-detection-toggle">
                    <span className="co-toggle-label">Konfliktprüfung aktiv</span>
                    <label className="co-apple-switch">
                        <input
                            type="checkbox"
                            checked={isDetectionEnabled}
                            onChange={(e) => onToggleDetection(e.target.checked)}
                        />
                        <span className="co-apple-slider"></span>
                    </label>
                </div>
                <button className="co-close-btn" onClick={onClose}>✕</button>
            </div>
        </div>
    );
};

export default ConflictHeader;
